"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationPlans = void 0;
var _reactRedux = require("react-redux");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _react = require("react");
var _useRecommendationStatus = require("./useRecommendationStatus");
var _constants = require("../../utils/constants");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// import * as sec from '@vf-org/smapi-js';

var getSelectedPlan = function getSelectedPlan() {
  var selectedPlan = (0, _reactRedux.useSelector)(_recommendationSelectors.selectSelectedPlan);
  var selectedVariant = selectedPlan.selectedVariant;
  return _objectSpread(_objectSpread(_objectSpread({}, selectedPlan), selectedVariant), {}, {
    isAlternativePlan: false
  });
};
var getPlan = function getPlan(tier) {
  var plan = (0, _reactRedux.useSelector)(function (state) {
    return (0, _recommendationSelectors.selectPlan)(state, tier);
  });
  if (!plan) {
    return null;
  }
  return _objectSpread({}, plan);
};
var getAlternativePlans = function getAlternativePlans() {
  var selectedPlan = (0, _reactRedux.useSelector)(_recommendationSelectors.selectSelectedPlan);
  var plans = (0, _reactRedux.useSelector)(_recommendationSelectors.selectRecommendationPlans);
  return plans.filter(function (plan) {
    return plan.productId !== selectedPlan.productId;
  }).map(function (plan) {
    return _objectSpread(_objectSpread(_objectSpread({}, plan), plan.selectedVariant), {}, {
      priceGapValue: plan.selectedVariant.price.priceValue - selectedPlan.selectedVariant.price.priceValue,
      isAlternativePlan: true
    });
  });
};
var useRecommendationPlans = function useRecommendationPlans() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useRecommendationSta = (0, _useRecommendationStatus.useRecommendationStatus)(),
    arePlansPresent = _useRecommendationSta.arePlansPresent;
  if (!arePlansPresent) {
    return {};
  }
  var recommendedPlan = getPlan(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  var premiumPlan = getPlan(_constants.RECOMMENDATION_TIER.PREMIUM);
  var budgetPlan = getPlan(_constants.RECOMMENDATION_TIER.BUDGET);
  var alternativePlan = getPlan(_constants.RECOMMENDATION_TIER.ALTERNATIVE);
  var alternativePremiumPlan = !premiumPlan && alternativePlan;
  var alternativeBudgetPlan = !budgetPlan && alternativePlan;
  var selectedPlan = getSelectedPlan();
  var alternativePlans = getAlternativePlans();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAlternativePlanContainerOpen = _useState2[0],
    setIsAlternativePlanContainerOpen = _useState2[1];
  var onPlanSelect = function onPlanSelect(productId) {
    setIsAlternativePlanContainerOpen(false);
    dispatch((0, _recommendationActions.updateSelectedPlan)(productId));
  };
  // sec.logCustomEvent(
  //   'recommendation',
  //   `Recommended Plan: ${selectedPlan?.productName},
  //     Premium plan: ${premiumPlan?.productName},
  //     Budget plan: ${budgetPlan?.productName},
  //     Alt Premium plan: ${alternativePremiumPlan?.productName},
  //     Alt Budget plan: ${alternativeBudgetPlan?.productName},
  //     Alternative plans: ${alternativePlans?.map(plan => {
  //       return plan?.productName;
  //     })}`,
  //   'recommendationPage',
  //   'recommendation plans',
  // );
  return {
    recommendedPlan: recommendedPlan,
    premiumPlan: premiumPlan,
    budgetPlan: budgetPlan,
    alternativePremiumPlan: alternativePremiumPlan,
    alternativeBudgetPlan: alternativeBudgetPlan,
    selectedPlan: selectedPlan,
    alternativePlans: alternativePlans,
    isAlternativePlanContainerOpen: isAlternativePlanContainerOpen,
    setIsAlternativePlanContainerOpen: setIsAlternativePlanContainerOpen,
    onPlanSelect: onPlanSelect
  };
};
exports.useRecommendationPlans = useRecommendationPlans;